import { AbstractControl, FormGroup } from '@angular/forms';
import { CountryCode, parsePhoneNumberFromString, PhoneNumber } from 'libphonenumber-js/max';

export function phoneNumberValidator(control: AbstractControl): { [key: string]: any } | null {
  if (!control.value || control.value.trim() === '') {
    return null;
  }
  const phoneNumberString: string = control.value;

  // A number entered with an explicit country code (e.g. "+34 600 700 800") can
  // belong to any country, so parse it without a country hint first.
  let phoneNumber: PhoneNumber = parsePhoneNumberFromString(phoneNumberString);

  // For bare local numbers (no leading "+"), fall back to the default country hints.
  if (!phoneNumber || !phoneNumber.isValid()) {
    const fallbackCountries: CountryCode[] = ['CA', 'GB', 'US'];
    fallbackCountries.some(fallbackCountry => {
      phoneNumber = parsePhoneNumberFromString(phoneNumberString, fallbackCountry);
      return phoneNumber && phoneNumber.isValid();
    });
  }

  const isPhoneNumberValid = !!(phoneNumber && phoneNumber.isValid());

  const invalidPhoneNumberReturn = {
    invalidPhoneNumber: { value: 'Invalid phone number. Please try adding a country code' }
  };

  // Normalize to E.164 so the server's AWSPhone scalar always receives a
  // fully-qualified number (auto country code injection).
  if (isPhoneNumberValid && phoneNumber.number !== phoneNumberString) {
    control.setValue(phoneNumber.number);
  }

  return isPhoneNumberValid ? null : invalidPhoneNumberReturn;
}

export function phoneNumberAndCountryCodeValidator(
  phoneControlName: string,
  countryCodeControlName: string
) {
  return (group: FormGroup) => {
    const phoneControl = group.controls[phoneControlName];
    const countryCodeControl = group.controls[countryCodeControlName];
    const phoneNumberWithCountryCode: PhoneNumber = parsePhoneNumberFromString(
      '' + (countryCodeControl.value + phoneControl.value)
    );

    if (
      (!phoneNumberWithCountryCode || !phoneNumberWithCountryCode.isValid()) &&
      phoneControl.value &&
      countryCodeControl.value
    ) {
      countryCodeControl.setErrors({
        invalidPhoneNumberOrCountryCode: true
      });
      phoneControl.setErrors({
        invalidPhoneNumberOrCountryCode: true
      });
      countryCodeControl.markAsTouched();
      phoneControl.markAsTouched();
    } else {
      deleteProperty(phoneControl, 'invalidPhoneNumberOrCountryCode');
      deleteProperty(countryCodeControl, 'invalidPhoneNumberOrCountryCode');
    }
    return null;
  };
}

function deleteProperty(control: AbstractControl, property) {
  if (control.errors) {
    delete control.errors[property];
    if (!Object.keys(control.errors).length) {
      control.setErrors(null);
    }
  }
}
